import { useEffect, useState } from 'react';
import { ApiKeyManager } from '../utils/apiKeyManager';

/**
 * Hook to manage API key initialization and state
 */
export function useApiKey() {
  const [apiKey, setApiKey] = useState<string | null>(null);
  const [apiKeySource, setApiKeySource] = useState<'url' | 'localStorage' | 'environment' | 'none'>('none');
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize API key on component mount
    const initializeApiKey = () => {
      const key = ApiKeyManager.getApiKey();
      const source = ApiKeyManager.getApiKeySource();
      
      setApiKey(key);
      setApiKeySource(source);
      setIsInitialized(true);

      if (key) {
        console.log(`API key loaded from: ${source}`);
      } else {
        console.warn('No API key found. Please add ?k=your_api_key to URL or set REACT_APP_API_KEY environment variable');
      }
    };

    initializeApiKey();
  }, []);

  const updateApiKey = (newApiKey: string) => {
    ApiKeyManager.saveApiKeyToStorage(newApiKey);
    setApiKey(newApiKey);
    setApiKeySource('localStorage');
  };

  const clearApiKey = () => {
    ApiKeyManager.clearApiKey();
    setApiKey(ApiKeyManager.getApiKey());
    setApiKeySource(ApiKeyManager.getApiKeySource());
  };

  return {
    apiKey,
    apiKeySource,
    isInitialized,
    hasApiKey: !!apiKey,
    updateApiKey,
    clearApiKey
  };
}